<router-outlet></router-outlet>

<div id="notifications-block">
</div>